import { FC } from "react"
import cn from "classnames"

import NoValue from "components/NoValue/NoValue"
import FlexibleContent from "components/FlexibleContent/FlexibleContent"
import HelpButton from "components/HelpButton/HelpButton"
import { Grid } from "components/Grid"
import { ITooltipProps } from "components/Tooltip/Tooltip"

interface IErpValueProps {
    text: string
    isInvalid?: boolean
    isItalic?: boolean
    isBold?: boolean
    tooltip?: ITooltipProps
}

const ErpValue: FC<IErpValueProps> = ({
    text,
    isInvalid,
    isItalic,
    isBold,
    tooltip,
}) => {

    return (
        <NoValue isInvalid={isInvalid} className={cn({
            "font-italic": isItalic,
            "font-bold": isBold,
        })}>
            <Grid justifyContent="start" gap="0.8rem" columns={!!tooltip ? "minmax(0, auto) max-content" : "1fr"}>
                <FlexibleContent text={text} className={isItalic && !text.endsWith(".") ? "pr-half" : ""} />
                {!!tooltip &&
                    <HelpButton tooltipProps={tooltip} />
                }
            </Grid>
        </NoValue>
    )

}

export default ErpValue
